import React from 'react';
import LayoutHeader from '../../layout/LayoutHeader';
import AddCard from '../../components/Focuspage/AddCard';

export default function Appshub() {
    return (
        <LayoutHeader>
            <div className="w-[390px] flex flex-col justify-start items-center relative z-[0]">
                <div className='px-4 my-[50px] flex w-full justify-between'>
                    <p className='text-white'>Your Apps</p>
                </div>

                <div className="w-full px-4 flex flex-col gap-4 mb-6">
                    <AddCard 
                        txt="Team Management" 
                        link="/team-management" 
                        dotimgclss={false} 
                    />
                    <AddCard 
                        txt="Create a new app" 
                        link="/apps/create" 
                        dotimgclss={false} 
                    />
                </div>
            </div>
        </LayoutHeader>
    );
}
